import React, { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PageContainer from '../_common/PageContainer';
import { PageHeaderUIContainer } from '../_common/PageHeaderUi';
import { SettingsProps } from './SettingsContainer';
import LinearProgress from 'components/_common/LinearProgress';
import { styles } from './Settings.styles';
import DesktopPreferences from './DesktopPreferences';
import DesktopDTFUnits from './DesktopDTFUnits';
import DesktopLanguage from './DesktopLanguage';

interface DesktopSettingsProps extends SettingsProps {
  updatedSettings: any;
  handleChangeDefaultValue: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeViewMode: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeLength: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeMetrics: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeLang: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DesktopSettings = React.memo((props: DesktopSettingsProps) => {
  const {
    userSettings,
    updatedSettings,
    isProductionHoursConfigured,
    handleChangeDefaultValue,
    handleChangeViewMode,
    handleChangeLength,
    handleChangeMetrics,
    handleChangeLang,
  } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <PageContainer>
        <PageHeaderUIContainer>
          <Box sx={styles.titleWrapper}>
            <Box component="img" src="/img/setting-icon.svg" sx={styles.icon} />
            <Typography variant="h1" sx={styles.title}>
              {t('settings.settings')}
            </Typography>
          </Box>
        </PageHeaderUIContainer>
        {!userSettings.isLoading ? (
          <Box sx={styles.settingsWrapper}>
            <Box sx={styles.leftPart}>
              <DesktopPreferences
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                isProductionHoursConfigured={isProductionHoursConfigured}
                handleChangeDefaultValue={handleChangeDefaultValue}
                handleChangeViewMode={handleChangeViewMode}
              />
              <DesktopDTFUnits
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                handleChangeLength={handleChangeLength}
                handleChangeMetrics={handleChangeMetrics}
              />
            </Box>
            <Box sx={styles.rightPart}>
              <DesktopLanguage
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                handleChangeLang={handleChangeLang}
              />
            </Box>
          </Box>
        ) : (
          <LinearProgress />
        )}
      </PageContainer>
    </Fragment>
  );
});

export default DesktopSettings;
